import React from "react";
import { Button } from "react-admin";
import { useNavigate } from "react-router";
import AddIcon from "@mui/icons-material/Add";
import { CURRICULUMS, MODULES, StudentServicePath } from "utils/constants";

const CreateModuleButton = ({ canCreate, id, curriculumName }) => {
  const navigate = useNavigate();
  if (!canCreate) return null;

  return (
    <Button
      variant="text"
      label="Създай"
      startIcon={<AddIcon />}
      onClick={() =>
        navigate(`/${StudentServicePath}${MODULES}/${CURRICULUMS}/${id}/create`, {
          state: { curriculumName },
        })
      }
      sx={{ mb: 1 }}
    />
  );
};

export default CreateModuleButton;
